import { Post } from './api';
import PostCard from './PostCard';
import SunMark from './SunMark';

interface Props {
  posts: Post[];
  onNew: () => void;
  onEdit: (post: Post) => void;
  onDelete: (id: number) => void;
}

export default function PostList({ posts, onNew, onEdit, onDelete }: Props) {
  return (
    <div>
      <div className="mb-8 flex items-center justify-between gap-6">
        <h1 className="font-trirong_reg text-[36px] leading-none text-lime-700">Blogs</h1>
        <button
          type="button"
          onClick={onNew}
          className="rounded-full bg-lime-700 px-5 py-2.5 font-trirong_reg text-[#f7faec] shadow-sm
                     transition-colors hover:bg-lime-800 focus:outline-none focus:ring-2 focus:ring-lime-600/40"
        >
          Write a new blog
        </button>
      </div>

      {posts.length === 0 ? (
        <div className="flex flex-col items-center gap-4 px-6 py-20 text-center">
          <div className="flex h-24 w-24 items-center justify-center rounded-full bg-gradient-to-br from-[#e2ecc6] to-[#cdd9a6] text-lime-700">
            <SunMark className="h-10 w-10" />
          </div>
          <h2 className="font-trirong_reg text-[26px] text-gray-800">No blogs yet</h2>
          <p className="max-w-xl font-trirong_light leading-relaxed text-gray-600">
            This is where your writing will live. When you publish a blog it appears on your
            website; drafts stay private until you are ready.
          </p>
          <button
            type="button"
            onClick={onNew}
            className="mt-1.5 rounded-full bg-lime-700 px-5 py-2.5 font-trirong_reg text-[#f7faec]
                       shadow-sm transition-colors hover:bg-lime-800 focus:outline-none focus:ring-2 focus:ring-lime-600/40"
          >
            Write your first blog
          </button>
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-[30px] md:grid-cols-2">
          {posts.map((post) => (
            <PostCard
              key={post.id}
              post={post}
              onEdit={() => onEdit(post)}
              onDelete={() => onDelete(post.id)}
            />
          ))}
        </div>
      )}
    </div>
  );
}
